import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface GetShipinhaoCommentListParams extends ActiomCommonParams {
    lastBuff?: string; // 分页标记
    exportId?: string; // 导出ID
}

export interface CommentListResponse {
    errCode: number;
    errMsg: string;
    data: {
        list: CommentDetail[];
        totalCount: number;
        hasMore: boolean;
    };
}

export interface CommentDetail {
    commentId: string;
    content: string;
    createTime: number;
    likeCount: number;
    replyCount: number;
    userName: string;
    userAvatar: string;
}

export type GetCommentListAction = CommonAction<GetShipinhaoCommentListParams, CommentListResponse["data"]>;

export const getShipinhaoCommentList: GetCommentListAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://channels.weixin.qq.com/micro/interaction/comment",
        origin: "https://channels.weixin.qq.com",
        "content-type": "application/json",
        "finger-print-device-id": params.extraParam.fingerPrintDeviceId,
        "x-wechat-uin": params.extraParam.uin,
    };

    const http = new Http({
        headers,
    });

    const urlParams = new URLSearchParams({
        _aid: params.extraParam.aId,
        _rid: rid(),
        _pageUrl: "https://channels.weixin.qq.com/micro/interaction/comment",
    }).toString();

    const requestData = {
        lastBuff: params.lastBuff || "",
        exportId: params.exportId || "",
        commentSelection: false,
        forMcn: false,
        timestamp: Date.now().toString(),
        _log_finder_uin: "",
        _log_finder_id: params.extraParam?.finderUserName || "",
        rawKeyBuff: null,
        pluginSessionId: null,
        scene: 7,
        reqScene: 7,
    };

    const res = await http.api<CommentListResponse>({
        method: "post",
        url: `https://channels.weixin.qq.com/micro/interaction/cgi-bin/mmfinderassistant-bin/comment/comment_list?${urlParams}`,
        data: requestData,
    });

    console.log(res, "----res");

    const isSuccess = res?.errCode === 0;

    return response(isSuccess ? 0 : 414, res?.errMsg, res.data);
};
